import React from 'react';
import Header from '../components/Frontend/Header';
import Footer from '../components/Frontend/Footer';
import { Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import MockPackages from '../components/Frontend/MockPackages';
import ReactPixel from 'react-facebook-pixel';

class VideoCourse extends React.Component {
    constructor(props) {
        super(props);
        this.props.history.push(this.props.match.url);
    }
    componentDidMount() {

        // ReactGA.initialize('UA-157984080-1');
        // ReactGA.pageview(window.location.pathname + window.location.search);
        ReactPixel.init('3847665161963731');
        ReactPixel.pageView();
        if (window.location.href.indexOf('#packages') != -1) {
            window.location.hash='';
            window.location.hash='packages';
        }
    }


 render(){

    return (
    <React.Fragment>
    <Helmet htmlAttributes>
        <title>Language Academy</title>
     </Helmet>
    <Header />
        <div class="innerPage">
        <section className="bannerOuter">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 text-center">
                        <h1>Excel In PTE With This Mock Plan</h1>
                        <span>Complete Preparation Package To Achieve The Score You Desire</span><br />
                        <a href="javascript:;" className="downArrow"><img src="/images/banner-arrow.png" alt="banner-arrow" /></a>
                    </div>
                </div>
            </div>
        </section>
        </div>

        <MockPackages />

        <section className="refundPolicy">
            <div className="container">
                <div className="row">
                    <div className="col">
                        <div className="refundNote text-center">
                            <h4>Refund Policy</h4>
                            <p>We don't offer any refund in any given circumstances. Nevertheless, a refund is possible is in case you are charged extra due to a technical problem. The refund request should be initiated within 24 hours by sending an email with all the details on <a hrf="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    <Footer />
    </React.Fragment>);
    }
}

export default VideoCourse;
